<template>
  <div>
    <template v-if="isOnFreePlan">
      <PlanSelection @subscribe="handleSubscribe($event)" />
    </template>

    <template v-else>
      <b-row>
        <b-col cols="8" class="p-0">
          <SubscriptionList :subscriptions="subscriptions" />
        </b-col>
        <b-col>
          <PlanDetails @renovate="handleSubscribe($event)" />
        </b-col>
      </b-row>
    </template>
    <SubscriptionForm @stored="refresh()" ref="subscriptionForm" />
  </div>
</template>

<script>
import SubscriptionList from "@/components/subscription/lists/SubscriptionList";
import PlanSelection from "@/components/subscription/sections/PlanSelection";
import SubscriptionForm from "@/components/subscription/forms/subscriptionForm";
import PlanDetails from "@/components/subscription/cards/PlanDetails";

export default {
  components: {
    SubscriptionList,
    PlanSelection,
    SubscriptionForm,
    PlanDetails,
  },

  data: function () {
    return {
      last_subscription: {},
      subscriptions: {},
    };
  },

  computed: {
    isOnFreePlan() {
      return (
        this.last_subscription.plan_id == 1 ||
        this.last_subscription.plan_id == null
      );
    },
  },

  mounted() {
    this.getSubscriptions();
    this.getLastSubscription();
  },

  methods: {
    async refresh() {
      // document.location.reload(true);
      this.$store.dispatch("auth/loadUser");
      this.getSubscriptions();
      await this.getLastSubscription();
      this.$emit("stored");
    },

    handleSubscribe(plan) {
      this.$refs.subscriptionForm.open(plan);
    },

    async getLastSubscription() {
      this.$store.commit("showLoading");
      await axios
        .post("api/subscribe/subscription")
        .then((response) => {
          this.$store.commit("pageHasLoaded");

          this.last_subscription = response.data.subscription;

          this.$store.commit("setSubscription", {
            data: response.data.subscription,
          });

          this.$store.commit("userHasLoaded");
        })
        .catch((error) => {
          this.error = error;
        });
    },
    getSubscriptions() {
      this.$store.commit("showLoading");

      axios
        .post("api/subscribe/subscriptionsList")
        .then((response) => {
          this.$store.commit("pageHasLoaded");

          this.subscriptions = response.data.subscriptions.data;

          this.$store.commit("userHasLoaded");
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.error = error;
          this.$store.commit("hideLoading");
        });
    },
  },
};
</script>
